







































































































































  import {
    Component,
    Emit,
    Vue,
    Watch
  } from 'vue-property-decorator';
  import {
    GenerateBtn,
  } from '@/components'

  import 
    Map
   from '@/components/Map/Map.vue'

  import{
    profileGenerator,        
    api
  }
  from '@/repository'  

import { FetchRequest, Profile } from '@/entity';

  @Component({
    components: {
      GenerateBtn,
      Map
    }
  })
  export default class Home extends Vue {    
    
    private profiles: any = [];
    private profilesOriginal: any = [];
    private headers = [
          {
            text: 'Gener',
            align: 'start',            
            value: 'gender',
          },
          { text: 'Name', value: 'fullname' },
          { text: 'Email', value: 'email' },
          { text: 'Nat', value: 'nat' },
          { text: 'Born', value: 'born' },
          { text: 'Registered', value: 'registered' },
        ]
      
    private loading = false;

    private genders: any = []   
    private selectedGenders = ''
    private ages: any = []   
    private selectedAges = 0
    private nationalities: any = []   
    private selectedNationalities = ''

    private locInfo = ''

    async generateProfiles():Promise<void> {     
      this.loading = true;
      const response: FetchRequest = await profileGenerator(process.env.VUE_APP_NUM_OF_PROFILES)

      const pofilesMapped = response.results.map( (profile) => {

        const bornDate = new Date(profile.dob.date).toLocaleString().split(' ')[0]
        const registeredDate = new Date(profile.registered.date).toLocaleString().split(' ')[0]
        
        return {
          ...profile,
          fullname: `${profile.name.title} ${profile.name.first} ${profile.name.last}`,
          born: `${bornDate}`,
          registered: `${registeredDate}`,
        }
      })
      
      this.profiles = pofilesMapped;
      this.profilesOriginal = this.profiles;
      
      this.getFilterAvailibles()

      this.loading = false;

    }


    getFilterAvailibles(): void{
      this.genders =  Array.from([... new Set(this.profiles.map((profile: Profile) => profile.gender))])
      this.ages =  Array.from([... new Set(this.profiles.map((profile: Profile) => profile.dob.age))])
      this.nationalities =  Array.from([... new Set(this.profiles.map((profile: Profile) => profile.nat))])
    }

    @Watch('selectedGenders')
    filterByGener(): void{
      this.selectedAges= 0
      this.selectedNationalities = ''
      this.profiles = this.profilesOriginal
      this.profiles = this.profilesOriginal.filter( (profile: Profile) => profile.gender === this.selectedGenders)
    }
    
    @Watch('selectedAges')
    filterByAge(): void{
      this.selectedGenders= ''
      this.selectedNationalities = ''
      this.profiles = this.profilesOriginal

      this.profiles = this.profilesOriginal.filter( (profile: Profile) => profile.dob.age === this.selectedAges)
    }
    
    @Watch('selectedNationalities')
    filterByNationalities(): void{
      this.selectedAges= 0
      this.selectedGenders = ''
      this.profiles = this.profilesOriginal

      this.profiles = this.profilesOriginal.filter( (profile: Profile) => profile.nat === this.selectedNationalities)
    }    

    @Emit()
    saveFavorite(item: Profile): void{
        api.create(item).then((response) => {
          console.log(response)
        })
      
    }
  }

